import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom"
import useScrollPosition from "../../hooks/useScrollPosition";
import { setIsModalOpen, setSectionOpen } from "../../redux/searchbarSlice";
import { setScroll } from "../../redux/scrollSlice";

const BaseBar = () => {
    const { link } = useSelector(state => state.backlink)
    const { isLogged } = useSelector(state => state.user);
    const location = useLocation();
    const url = location.pathname;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const scrollPosition = useScrollPosition();

    // La modale di ricerca (SearchBar) non ha più un tasto di chiusura proprio: si chiude
    // con l'indietro di questa barra. Finché è aperta, "indietro" chiude la modale invece
    // di navigare — ed è attivo anche in home, dove normalmente è disabilitato.
    const { isModalOpen: isSearchModalOpen } = useSelector(state => state.searchbar.modal);

    const [isHome, setIsHome] = useState(false);
    const [isProfile, setIsProfile] = useState(false);
    const [isFavourites, setIsFavourites] = useState(false);

    useEffect(() => {
        if (url === "/") {
            setIsHome(true)
        } else {
            setIsHome(false)
        }
        if (url === "/my-profile") {
            setIsProfile(true)
        } else {
            setIsProfile(false)
        }
        if (url === "/favourites") {
            setIsFavourites(true)
        }
        else {
            setIsFavourites(false)
        }
    }, [url])

    const handleBackClick = () => {
        if (isSearchModalOpen) {
            dispatch(setSectionOpen(null));
            dispatch(setIsModalOpen(false));
            dispatch(setScroll(true));
            return;
        }
        navigate(-1);
        // Se l'utente torna da una pagina dettaglio, resetto il backlink
        // e al ritorno indietro non scrolla in alto
        if (link === "/activity-details") return;
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 10)
    }

    const handleHomeClick = () => {
        if(scrollPosition < 80) return;
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    // Stile icone: nessun bordo/rettangolo, solo icone.
    //  - verde (#225424) = pagina attiva (l'utente sa dov'è)
    //  - nero            = navigabile
    //  - grigio          = disabilitato (azione non disponibile)
    // Eccezione: il tasto "indietro" non diventa mai verde (nessuna pagina associata).
    const iconBox = "w-12 h-12 flex justify-center items-center";

    return (
        // z-[45]: sopra la modale di ricerca (z-40), che deve poter essere chiusa da qui,
        // ma sotto gli overlay a tutto schermo con chiusura propria (drawer, filtri: z-50).
        <div className="fixed left-0 right-0 bottom-0 z-[45] w-full flex justify-center md:hidden bg-white py-4">
            <div className="w-full flex justify-evenly">
                {/* back — mai verde; nero se navigabile, grigio (disabilitato) solo in home */}
                {
                    (!isHome || isSearchModalOpen) &&
                    <div className={`${iconBox} cursor-pointer`} onClick={handleBackClick}>
                        <div className="pt-1"><i className="fi fi-rr-angle-left text-2xl text-black"></i></div>
                    </div>
                }
                {
                    (isHome && !isSearchModalOpen) &&
                    <div className={iconBox}>
                        <div className="pt-1"><i className="fi fi-rr-angle-left text-2xl text-slate-300"></i></div>
                    </div>
                }

                {/* home — verde se pagina attiva, nero altrimenti */}
                {
                    !isHome &&
                    <Link to="/">
                        <div className={iconBox}>
                            <div className="pt-1"><i className="fi fi-rr-house-chimney text-2xl text-black"></i></div>
                        </div>
                    </Link>
                }
                {
                    isHome &&
                    <div className={`${iconBox} cursor-pointer`} onClick={handleHomeClick}>
                        <div className="pt-1"><i className="fi fi-sr-house-chimney text-2xl text-[#225424]"></i></div>
                    </div>
                }

                {/* favourites — verde se pagina attiva, nero se navigabile, grigio se non loggato */}
                {
                    (isLogged && isFavourites) &&
                    <div className={iconBox}>
                        <div className="pt-1"><i className="fi fi-sr-heart text-2xl text-[#225424]"></i></div>
                    </div>
                }
                {
                    (isLogged && !isFavourites) &&
                    <Link to="/favourites">
                        <div className={iconBox}>
                            <div className="pt-1"><i className="fi fi-rr-heart text-2xl text-black"></i></div>
                        </div>
                    </Link>
                }
                {
                    !isLogged &&
                    <div className={iconBox}>
                        <div className="pt-1"><i className="fi fi-rr-heart text-2xl text-slate-300"></i></div>
                    </div>
                }


                {/* profile — verde se pagina attiva, nero se navigabile, grigio se non loggato */}
                {
                    (isLogged && isProfile) &&
                    <div className={iconBox}>
                        <div className="pt-1"><i className="fi fi-sr-user text-2xl text-[#225424]"></i></div>
                    </div>
                }
                {
                    (isLogged && !isProfile) &&
                    <Link to="/my-profile">
                        <div className={`${iconBox} cursor-pointer`}>
                            <div className="pt-1"><i className="fi fi-rr-user text-2xl text-black"></i></div>
                        </div>
                    </Link>
                }
                {
                    !isLogged &&
                    <div className={iconBox}>
                        <div className="pt-1"><i className="fi fi-rr-user text-2xl text-slate-300"></i></div>
                    </div>
                }

            </div>
        </div>
    )
}

export default BaseBar